(function(){
  'use strict';

  var cdTimer = null;
  /* one teardown function per initialised section — see shopify:section:unload */
  var cleanups = [];

  /* ---------------- axis detection ----------------
     MUST stay identical in logic to sections/pdp-rebuilt.liquid.
     Match = option name, lowercased AND trimmed, CONTAINS a pattern.
     SIZE is tested FIRST for every option, so a name like "Shoe size" can
     never be captured by a colour rule; only if it is not a size do we test
     the colour patterns. First match wins per axis; everything else (an
     unrecognised name, a 3rd option, a duplicate of a claimed axis) becomes
     an "extra" axis and is still rendered and matched — never dropped. */
  var SIZE_PATS  = ['size', 'sizes', 'مقاس', 'مقاسات'];
  var COLOR_PATS = ['color', 'colour', 'لون', 'الوان', 'ألوان'];

  function hasPat(name, pats){
    var n = String(name == null ? '' : name).toLowerCase().replace(/^\s+|\s+$/g, '');
    for(var i=0;i<pats.length;i++){ if(n.indexOf(pats[i]) > -1) return true; }
    return false;
  }
  function axisOf(name){
    if(hasPat(name, SIZE_PATS))  return 's';
    if(hasPat(name, COLOR_PATS)) return 'c';
    return 'x';
  }
  function axesFromNames(names){
    var out = {c:-1, s:-1, x:[]};
    for(var i=0;i<names.length;i++){
      var a = axisOf(names[i]);
      if(a === 's' && out.s < 0)      out.s = i;
      else if(a === 'c' && out.c < 0) out.c = i;
      else                            out.x.push(i);
    }
    return out;
  }

  function init(root){
    if(!root || root.__pdpInit) return;
    root.__pdpInit = true;
    clearTimeout(cdTimer);

    /* translated strings come from data attributes on the section root;
       the Arabic literal stays as the fallback so behaviour is unchanged
       if an attribute is ever missing or blank */
    function tr(name, fallback){
      var v = root && root.getAttribute(name);
      return (v === null || v === undefined || v === '') ? fallback : v;
    }

    /* Locale-aware URLs. The store publishes more than one locale, so a hard
       '/cart/add.js' would 404 or drop the locale on /en/cart.
       Same helper as assets/cart-rebuilt.js so both files behave identically. */
    function url(path){
      var base = tr('data-routes-root', '/');
      if (base.charAt(base.length - 1) !== '/') base += '/';
      return base + String(path).replace(/^\//, '');
    }

    var variants = [], idx = {c:-1, s:-1, x:[]}, optNames = [];
    try{ variants = JSON.parse(root.querySelector('[data-variants]').textContent) || []; }catch(e){ return; }
    try{ idx = JSON.parse(root.querySelector('[data-optidx]').textContent) || idx; }catch(e){}
    try{ optNames = JSON.parse(root.querySelector('[data-optnames]').textContent) || []; }catch(e){}

    /* the option names are the single source of truth: recompute the axes here
       with the logic above so the JS can never disagree with the Liquid. The
       data-optidx island stays as the fallback when names are unavailable. */
    var namesUsable = !!(optNames && optNames.length);
    for(var ni=0; namesUsable && ni<optNames.length; ni++){
      if(typeof optNames[ni] !== 'string' || optNames[ni] === '') namesUsable = false;
    }
    if(namesUsable){
      idx = axesFromNames(optNames);
    } else {
      if(!idx || typeof idx.c !== 'number' || typeof idx.s !== 'number') idx = {c:-1, s:-1, x:[]};
      if(Object.prototype.toString.call(idx.x) !== '[object Array]') idx.x = [];
    }

    /* extra (non colour / non size) axes, read back off what Liquid actually
       rendered so the JS only ever matches groups that exist in the DOM */
    var extraIdx = [];
    (function(){
      var seen = {};
      var nodes = root.querySelectorAll('[data-extra][data-optindex]');
      for(var i=0;i<nodes.length;i++){
        var n = parseInt(nodes[i].getAttribute('data-optindex'), 10);
        if(!isNaN(n) && !seen[n]){ seen[n] = 1; extraIdx.push(n); }
      }
    })();

    var moneyFormat = root.getAttribute('data-money-format') || 'LE {{amount_no_decimals}}';

    var elVariantId = root.querySelector('[data-variant-id]');
    var elPrice     = root.querySelector('[data-price]');
    var elCompare   = root.querySelector('[data-compare]');
    var elOff       = root.querySelector('[data-off]');
    var elFlag      = root.querySelector('[data-save-flag]');
    var elColorName = root.querySelector('[data-color-name]');
    var elStock     = root.querySelector('[data-stock]');
    var elCta       = root.querySelector('[data-cta]');
    var elPay       = root.querySelector('.pdp__pay');
    var elAddErr    = root.querySelector('[data-add-error]');
    var form        = root.querySelector('form[action*="/cart/add"]');

    /* ---------------- gallery slider ---------------- */
    var track   = root.querySelector('[data-slides]');
    var slides  = [].slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs  = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var counter = root.querySelector('[data-counter]');
    var btnPrev = root.querySelector('[data-prev]');
    var btnNext = root.querySelector('[data-next]');
    var current = 0;

    /* RTL-safe scrolling. The storefront is RTL and .pdp__slides carries no
       direction override, so in this scroller scrollLeft runs from
       -(scrollWidth - clientWidth) up to 0 while offsetLeft stays positive.
       An absolute scrollTo({left: offsetLeft - track.offsetLeft}) therefore
       always gets a positive number, clamps to 0, and parks on slide 0 for
       every target i. A SIGNED viewport-relative delta handed to scrollBy()
       is correct in both LTR and RTL and needs no direction sniffing. */
    function goTo(i, smooth){
      if(!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      var delta = s.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: smooth === false ? 'auto' : 'smooth' });
      setCurrent(i);
    }
    function setCurrent(i){
      current = i;
      if(counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function(t){
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'),10) === i);
      });
      var active = thumbs[i];
      if(active && active.scrollIntoView) active.scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'});
      if(btnPrev) btnPrev.disabled = (i === 0);
      if(btnNext) btnNext.disabled = (i === slides.length - 1);
    }
    /* same RTL problem, mirrored: scrollLeft is negative here while every
       slide centre computed from offsetLeft is positive, so after a manual
       swipe the nearest slide always resolved to the last one. Comparing
       getBoundingClientRect() centres keeps both sides in the same signed
       viewport space, so the maths is direction-agnostic. */
    function nearestIndex(){
      if(!track) return 0;
      var best = 0, bestD = Infinity;
      var tRect = track.getBoundingClientRect();
      var mid = tRect.left + tRect.width / 2;
      slides.forEach(function(s, i){
        var r = s.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - mid);
        if(d < bestD){ bestD = d; best = i; }
      });
      return best;
    }

    if(track){
      var sTimer;
      track.addEventListener('scroll', function(){
        clearTimeout(sTimer);
        sTimer = setTimeout(function(){ setCurrent(nearestIndex()); }, 90);
      }, {passive:true});
    }
    if(btnPrev) btnPrev.addEventListener('click', function(){ goTo(current - 1); });
    if(btnNext) btnNext.addEventListener('click', function(){ goTo(current + 1); });
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-index'),10)); });
    });

    /* map a variant image to its slide index.
       PRIMARY key is the Shopify image id, rendered into data-img-id by
       sections/pdp-rebuilt.liquid: it is the only value guaranteed unique per
       image. The old filename substring match could resolve to the wrong
       slide whenever two images share a filename stem.
       FALLBACK: the original filename match is kept verbatim and runs
       whenever no id is supplied or no slide carries a matching data-img-id,
       so a slide rendered without the attribute still behaves as before. */
    function slideIndexForSrc(src, id){
      if(id !== null && id !== undefined && id !== ''){
        var wanted = String(id);
        for(var k=0;k<slides.length;k++){
          if(slides[k].getAttribute('data-img-id') === wanted) return k;
        }
      }
      if(!src) return -1;
      var key = src.split('/').pop().split('?')[0];
      for(var i=0;i<slides.length;i++){
        var im = slides[i].querySelector('img');
        if(im && im.getAttribute('src').indexOf(key) > -1) return i;
      }
      return -1;
    }

    /* ---------------- money ---------------- */
    /* ported from assets/cart-rebuilt.js: handles all 8 Shopify money tokens,
       so the PDP and the cart can never disagree on a price */
    function formatMoney(cents){
      var value = typeof cents === 'number' ? cents : parseInt(cents, 10);
      if (isNaN(value)) value = 0;
      var fmt = (moneyFormat && moneyFormat.indexOf('{{') !== -1) ? moneyFormat : '{{amount}}';

      function build(precision, thousands, decimal){
        var fixed = (value / 100.0).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }

      var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(match, name){
        switch (name){
          case 'amount': return build(2, ',', '.');
          case 'amount_no_decimals': return build(0, ',', '');
          case 'amount_with_comma_separator': return build(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return build(0, '.', '');
          case 'amount_with_apostrophe_separator': return build(2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return build(0, ' ', '');
          case 'amount_with_space_separator': return build(2, ' ', ',');
          case 'amount_with_period_and_space_separator': return build(2, ' ', '.');
          default: return build(2, ',', '.');
        }
      });
      return out.replace(/<[^>]*>/g,'').trim();
    }

    /* ---------------- variants ---------------- */
    function selected(name){
      var i = root.querySelector('input[name="'+name+'"]:checked');
      return i ? i.value : null;
    }
    /* current selection of every extra axis, as [{i: optionIndex, v: value|null}] */
    function extraSel(){
      var out = [];
      for(var k=0;k<extraIdx.length;k++){
        var ei = extraIdx[k];
        var inp = root.querySelector('input[name="pdp-opt-'+ei+'"]:checked');
        out.push({ i: ei, v: inp ? inp.value : null });
      }
      return out;
    }
    function findVariant(color, size, extras){
      if(extras === undefined) extras = extraSel();
      for(var i=0;i<variants.length;i++){
        var v = variants[i], ok = true;
        if(idx.c > -1 && color != null && v.options[idx.c] !== color) ok = false;
        if(ok && idx.s > -1 && size != null && v.options[idx.s] !== size) ok = false;
        if(ok && extras){
          for(var j=0;j<extras.length;j++){
            var e = extras[j];
            if(e.v != null && v.options[e.i] !== e.v){ ok = false; break; }
          }
        }
        if(ok) return v;
      }
      return null;
    }
    function refreshSizes(){
      if(idx.s < 0) return;
      var color = selected('pdp-color');
      root.querySelectorAll('[data-size]').forEach(function(lbl){
        var v = findVariant(color, lbl.getAttribute('data-value'));
        var ok = !!(v && v.available);
        lbl.classList.toggle('is-soldout', !ok);
        var input = lbl.querySelector('input');
        if(input) input.disabled = !ok;
      });
    }
    /* same availability pass as refreshSizes, for every extra axis */
    function refreshExtras(){
      if(!extraIdx.length) return;
      var color = selected('pdp-color'), size = selected('pdp-size');
      var all = extraSel();
      extraIdx.forEach(function(ei){
        var base = all.filter(function(e){ return e.i !== ei; });
        root.querySelectorAll('[data-extra][data-optindex="'+ei+'"]').forEach(function(lbl){
          var probe = base.concat([{ i: ei, v: lbl.getAttribute('data-value') }]);
          var v = findVariant(color, size, probe);
          var ok = !!(v && v.available);
          lbl.classList.toggle('is-soldout', !ok);
          var input = lbl.querySelector('input');
          if(input) input.disabled = !ok;
        });
      });
    }
    function clearExtras(){
      extraIdx.forEach(function(ei){
        var c = root.querySelector('input[name="pdp-opt-'+ei+'"]:checked');
        if(c) c.checked = false;
      });
      root.querySelectorAll('[data-extra]').forEach(function(l){ l.classList.remove('is-active'); });
    }
    /* true when at least one extra axis exists and has nothing chosen */
    function extrasMissing(){
      for(var k=0;k<extraIdx.length;k++){
        if(!root.querySelector('input[name="pdp-opt-'+extraIdx[k]+'"]:checked')) return true;
      }
      return false;
    }
    function missingGroupEl(){
      for(var k=0;k<extraIdx.length;k++){
        var ei = extraIdx[k];
        if(!root.querySelector('input[name="pdp-opt-'+ei+'"]:checked')){
          var lbl = root.querySelector('[data-extra][data-optindex="'+ei+'"]');
          if(lbl) return lbl.parentNode;
        }
      }
      return null;
    }

    /* C1: the dynamic checkout button posts the form on its own and never
       reaches our submit handler, so while no valid variant is resolved the
       whole container is hidden AND its controls disabled. Both are undone
       the moment a real variant resolves. */
    function setExpress(enabled){
      if(!elPay) return;
      if(enabled){
        elPay.hidden = false;
        elPay.removeAttribute('aria-hidden');
        if(elPay.style) elPay.style.display = '';
      } else {
        elPay.hidden = true;
        elPay.setAttribute('aria-hidden', 'true');
        if(elPay.style) elPay.style.display = 'none';
      }
      var nodes = elPay.querySelectorAll('button, input, [role="button"]');
      for(var i=0;i<nodes.length;i++){
        var n = nodes[i];
        if(enabled){
          if(n.hasAttribute('data-pdp-pay-off')){
            n.removeAttribute('disabled');
            n.removeAttribute('data-pdp-pay-off');
          }
        } else if(!n.disabled){
          n.setAttribute('disabled','disabled');
          n.setAttribute('data-pdp-pay-off','');
        }
      }
    }

    function render(changedColor){
      var color = selected('pdp-color'), size = selected('pdp-size');

      root.querySelectorAll('[data-swatch]').forEach(function(l){
        l.classList.toggle('is-active', l.getAttribute('data-value') === color);
      });
      root.querySelectorAll('[data-size]').forEach(function(l){
        l.classList.toggle('is-active', l.getAttribute('data-value') === size);
      });
      root.querySelectorAll('[data-extra]').forEach(function(l){
        var cur = root.querySelector('input[name="pdp-opt-'+l.getAttribute('data-optindex')+'"]:checked');
        l.classList.toggle('is-active', !!cur && cur.value === l.getAttribute('data-value'));
      });
      if(elColorName && color) elColorName.textContent = color;

      var v = findVariant(color, size);
      if(!v && idx.s > -1){
        var checked = root.querySelector('input[name="pdp-size"]:checked');
        if(checked) checked.checked = false;
        root.querySelectorAll('[data-size]').forEach(function(l){ l.classList.remove('is-active'); });
        size = null;
        /* C1: never leave the previous variant's id in the form */
        if(elVariantId) elVariantId.value = '';
      }
      if(!v && extraIdx.length){
        /* a colour change can invalidate a previously chosen extra option —
           drop the dead selection instead of shipping an unbuyable state */
        clearExtras();
        if(elVariantId) elVariantId.value = '';
      }
      if(elVariantId && v) elVariantId.value = v.id;

      var src = v || findVariant(color, null) || variants[0];
      if(src){
        if(elPrice) elPrice.textContent = formatMoney(src.price);
        var disc = src.compare_at_price && src.compare_at_price > src.price;
        if(elCompare){ elCompare.textContent = disc ? formatMoney(src.compare_at_price) : ''; elCompare.hidden = !disc; }
        if(elOff){
          if(disc){
            var offSuffix = tr('data-t-off-suffix', '');
            elOff.textContent = tr('data-t-off-prefix','خصم') + ' ' + Math.round((src.compare_at_price - src.price) * 100 / src.compare_at_price) + '%' + offSuffix;
            elOff.hidden = false;
          } else elOff.hidden = true;
        }
        if(elFlag){
          if(disc){ elFlag.textContent = tr('data-t-save','وفّرِي') + ' ' + formatMoney(src.compare_at_price - src.price); elFlag.hidden = false; }
          else elFlag.hidden = true;
        }
        if(changedColor && src.featured_image && (src.featured_image.src || src.featured_image.id)){
          var i = slideIndexForSrc(src.featured_image.src, src.featured_image.id);
          if(i > -1) goTo(i);
        }
      }

      /* needsSize is true ONLY when a size axis actually exists AND no size is
         chosen. Extra axes get their own flag so single-option products can
         never be blocked by a size that does not exist. */
      var needsSize = (idx.s > -1 && !size);
      var needsOpt  = extrasMissing();

      if(elCta){
        if(needsSize || needsOpt){
          elCta.disabled = false; elCta.textContent = tr('data-t-pick-size','اختاري المقاس');
          if(needsSize) elCta.dataset.needsSize = '1'; else delete elCta.dataset.needsSize;
          if(needsOpt)  elCta.dataset.needsOpt  = '1'; else delete elCta.dataset.needsOpt;
        } else if(v && v.available){
          elCta.disabled = false; elCta.textContent = tr('data-t-atc','أضف إلى السلة');
          delete elCta.dataset.needsSize; delete elCta.dataset.needsOpt;
        } else {
          elCta.disabled = true; elCta.textContent = tr('data-t-unavailable','غير متاح حاليًا');
          delete elCta.dataset.needsSize; delete elCta.dataset.needsOpt;
        }
      }
      /* express checkout follows the same truth as the hidden id */
      setExpress(!!(v && v.id) && !needsSize && !needsOpt);
      if(elStock){
        if(v && v.available && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity <= 3){
          var stockSuffix = tr('data-t-stock-suffix','قطع بس');
          elStock.textContent = tr('data-t-stock-prefix','باقي') + ' ' + v.inventory_quantity + (stockSuffix ? ' ' + stockSuffix : ''); elStock.hidden = false;
        } else elStock.hidden = true;
      }
      syncBar();
    }

    root.addEventListener('change', function(e){
      var nm = e.target && e.target.name;
      if(nm === 'pdp-color'){ refreshSizes(); refreshExtras(); render(true); }
      else if(nm === 'pdp-size'){ refreshExtras(); render(false); }
      else if(nm && nm.indexOf('pdp-opt-') === 0){ refreshSizes(); refreshExtras(); render(false); }
    });

    /* ---------------- copy link ---------------- */
    var copyBtn = root.querySelector('[data-copy-link]');
    if(copyBtn){
      copyBtn.addEventListener('click', function(){
        var shareUrl = copyBtn.getAttribute('data-url') || location.href;
        var done = function(){
          var old = copyBtn.textContent;
          copyBtn.textContent = tr('data-t-copied','تم النسخ');
          setTimeout(function(){ copyBtn.textContent = old; }, 1600);
        };
        if(navigator.clipboard) navigator.clipboard.writeText(shareUrl).then(done).catch(function(){});
        else done();
      });
    }

    /* ---------------- add to cart ---------------- */
    function showAddError(){
      if(!elAddErr) return;
      elAddErr.textContent = tr('data-t-add-error','حصلت مشكلة، جرّبي تاني.');
      elAddErr.hidden = false;
    }
    function hideAddError(){
      if(!elAddErr) return;
      elAddErr.textContent = '';
      elAddErr.hidden = true;
    }

    /* M3: /cart/add.js answers with the LINE ITEM, not the cart. Only touch the
       badge when the payload really carries a cart-level count — a stale number
       is better than a wrong one, and we never poll to find out. */
    function syncCartCount(data){
      var count = null;
      if(data && typeof data.items_count === 'number') count = data.items_count;
      else if(data && typeof data.item_count === 'number') count = data.item_count;
      if(count !== null){
        var badges = document.querySelectorAll('[data-cart-count]');
        for(var i=0;i<badges.length;i++){ badges[i].textContent = count; }
      }
      if(typeof window.CustomEvent === 'function'){
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      }
    }

    if(form){
      form.addEventListener('submit', function(e){
        /* option prompt runs first: with a required axis unchosen the hidden id
           is empty, so the native POST below would send an empty id */
        if(elCta && (elCta.dataset.needsSize || elCta.dataset.needsOpt)){
          e.preventDefault();
          var sizes = elCta.dataset.needsSize ? root.querySelector('.pdp__sizes') : missingGroupEl();
          if(!sizes) sizes = missingGroupEl() || root.querySelector('.pdp__sizes');
          if(sizes){
            sizes.scrollIntoView({behavior:'smooth', block:'center'});
            if(sizes.animate) sizes.animate([{opacity:1},{opacity:.35},{opacity:1}], {duration:520, iterations:2});
          }
          return;
        }
        /* guard: if the pieces we need are missing, let the browser POST natively */
        if(!elCta || !elVariantId) return;
        var vid = parseInt(elVariantId.value, 10);
        if(!elVariantId.value || isNaN(vid) || vid <= 0) return;
        if(!window.fetch) return;
        e.preventDefault();
        hideAddError();
        elCta.classList.add('is-loading');
        var responded = false, added = false;
        fetch(url('cart/add.js'), {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body: JSON.stringify({ items:[{ id: parseInt(elVariantId.value,10), quantity: 1 }] })
        })
        .then(function(r){ responded = true; if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(data){ added = true; syncCartCount(data); openCart(); })
        .catch(function(err){
          /* M2: only resubmit when the request never reached the server — a
             network-level TypeError thrown by fetch itself. If the server did
             answer (or the body failed to parse) the line may already be in the
             cart, and form.submit() would add it a second time. */
          if(added) return;
          if(!responded && err && err.name === 'TypeError'){ form.submit(); return; }
          showAddError();
        })
        .finally(function(){ elCta.classList.remove('is-loading'); });
      });
    }
    function openCart(){
      var t = document.querySelector('a[href="#cart"]');
      if(t){ t.click(); return; }
      window.location.href = url('cart');
    }

    /* ---------------- mobile buy bar ---------------- */
    var bar = null;
    function buildBar(){
      if(bar || window.innerWidth >= 1000) return;
      bar = document.createElement('div');
      bar.className = 'pdp-bar';
      bar.innerHTML = '<span class="pdp-bar__price"></span><button type="button" class="pdp-bar__btn"></button>';
      document.body.appendChild(bar);
      bar.querySelector('.pdp-bar__btn').addEventListener('click', function(){ if(elCta) elCta.click(); });
      syncBar();
    }
    function syncBar(){
      if(!bar) return;
      var p = bar.querySelector('.pdp-bar__price');
      if(p && elPrice) p.textContent = elPrice.textContent;
      var b = bar.querySelector('.pdp-bar__btn');
      if(b && elCta){ b.textContent = elCta.textContent; b.disabled = elCta.disabled; }
    }
    function toggleBar(){
      if(!bar || !elCta) return;
      bar.classList.toggle('is-shown', elCta.getBoundingClientRect().bottom < 0);
    }
    var barTicking = false;
    function onScrollBar(){
      if(barTicking) return;
      barTicking = true;
      window.requestAnimationFrame(function(){ barTicking = false; toggleBar(); });
    }
    function onResizeBar(){ if(window.innerWidth < 1000) buildBar(); }
    buildBar();
    window.addEventListener('scroll', onScrollBar, {passive:true});
    window.addEventListener('resize', onResizeBar);

    /* N1/N2: the buy bar lives on <body>, outside the section, so the theme
       editor cannot remove it for us — take it down ourselves on unload. */
    cleanups.push(function(){
      window.removeEventListener('scroll', onScrollBar);
      window.removeEventListener('resize', onResizeBar);
      if(bar && bar.parentNode) bar.parentNode.removeChild(bar);
      bar = null;
      root.__pdpInit = false;
    });

    /* ---------------- countdown ---------------- */
    var cd = root.querySelector('[data-countdown]');
    if(cd){
      var clock = cd.querySelector('[data-clock]');
      var cutoff = new Date(); cutoff.setHours(17,0,0,0);
      if(cutoff <= new Date()) cutoff.setDate(cutoff.getDate()+1);
      cd.hidden = false;
      (function tick(){
        var diff = cutoff - new Date();
        if(diff <= 0){ cd.hidden = true; return; }
        var h = Math.floor(diff/3600000), m = Math.floor(diff%3600000/60000), s = Math.floor(diff%60000/1000);
        if(clock) clock.textContent = h + ' : ' + String(m).padStart(2,'0') + ' : ' + String(s).padStart(2,'0');
        cdTimer = setTimeout(tick, 1000);
      })();
    }

    setCurrent(0);
    refreshSizes();
    refreshExtras();
    render(false);
  }

  function boot(){ document.querySelectorAll('[data-pdp]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function(){
    clearTimeout(cdTimer); cdTimer = null;
    for(var i=0;i<cleanups.length;i++){ try{ cleanups[i](); }catch(e){} }
    cleanups.length = 0;
  });
})();
